import styled from 'styled-components'

import { Colors } from 'cio-design-library/design-tokens'
import { Media } from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 625px;

  ${Media.Phone`
    width: 100%;
    padding: 0 20px;
    gap: 12px;
  `}
`

export const StepContainer = styled.div`
  display: flex;
  gap: 24px;

  ${Media.Phone`
    gap: 6px;
  `}
`

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${Colors.Neutral20};
`

export const VerticalLine = styled.div`
  width: 1px;
  background-color: ${Colors.Neutral20};
`

export const Step = styled.div`
  flex: 1;
  text-align: center;
  padding: 8px 0;
`

export const StepTitle = styled.h3<{ count: number }>`
  ${Typography.Subhead};
  ${FontWeights.Medium};
  position: relative;

  color: ${Colors.Neutral80};

  &::before {
    content: '${({ count }) => `0${count} `}';
    ${Typography.Subhead};
    ${FontWeights.DemiBold};

    font-size: 14px;
    color: ${Colors.Neutral50};

    position: relative;
    top: -8px;
    right: 4px;

    ${Media.Phone`
      font-size: 12px;
    `}
  }
`

export const StepDescription = styled.p`
  ${Typography.Body};
  ${FontWeights.Regular};

  color: ${Colors.Neutral70};
`
